import { NgModule, inject } from "@angular/core";
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { AuthGuardService } from '../../services/auth-guard.service';

const routes: Routes = [
    
    // {
    //     path: '',
    //     loadChildren: () => import('../landing/landing.module').then(m => m.LandingModule)
    // },
    {
        path: 'auth',
        loadChildren: () => import('../authentication/authentication.module').then(m => m.AuthenticationModule)
        
    },
    {
        path: 'app',
        loadChildren: () => import('../admin/admin.module').then(m => m.AdminModule),
        data: {},
        canMatch: [(route: ActivatedRouteSnapshot) => inject(AuthGuardService).isLoggedIn(route)]
    },
    { path: '**', redirectTo: 'auth/login', pathMatch: 'full' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class CoreRoutingModule { }
